import React from 'react'
import { useHistory } from 'react-router-dom'
import { useApi, IPermissionsData } from '../providers/ApiProvider'
import * as permissionType from '../../constants/permissions'

export const PermissionsContext = React.createContext([])

export const usePermissions = () => {
  const context = React.useContext(PermissionsContext)
  if (!context) {
    throw new Error(
      'usePermissions must be used within a PermissionsContextProvider',
    )
  }
  return context
}

export const PermissionsContextProvider = ({ children }: any) => {
  const history = useHistory()
  const [permissionData, setPermissionsData] = React.useState<IPermissionsData[]>([])

  const api = useApi()

  React.useEffect(() => {
    api
      .getPermissions([
        { name: permissionType.PAGE_MY_PARKING_LOT_PARKING_LOT },
        { name: permissionType.PAGE_MY_PARKING_LOT_PARKING_LOT_MODIFY },
        { name: permissionType.PAGE_MY_PARKING_LOT_PARKING_LOT_NOTIFICATIONS },
        { name: permissionType.PAGE_MY_PARKING_LOT_PAYMENTS },
        { name: permissionType.PAGE_MY_PARKING_LOT_ANALYTICS },
        { name: permissionType.PAGE_MY_PARKING_LOT_CUSTOMER_NOTIFICATION_EXCLUSIONS },
        { name: permissionType.PAGE_SUBSCRIPTIONS_BUY },
        { name: permissionType.PAGE_SUBSCRIPTIONS_FREE_TIME },
        { name: permissionType.PAGE_SUBSCRIPTIONS_SUBSCRIPTIONS },
        { name: permissionType.PAGE_SUBSCRIPTIONS_PERMITS },
        { name: permissionType.PAGE_SUBSCRIPTIONS_SUBSCRIPTION_OFFERS },
        { name: permissionType.PAGE_RESERVATIONS_MY_RESERVATIONS },
        { name: permissionType.PAGE_RESERVATIONS_RESERVATIONS },
        { name: permissionType.PAGE_RESERVATIONS_RESERVATION_OFFERS },
      ])
      .then(res => {
        setPermissionsData(res)
      })
      .catch(() => {
        api.logout();
        history.push('/')
      })
  }, [api, history])

  return (
    <PermissionsContext.Provider value={permissionData}>
      {children}
    </PermissionsContext.Provider>
  )
}
